// ECOMM-12848: page the concierge's back button should return to.
const STORAGE_KEY = 'concierge:referrer';

type StoredReferrer = {
  path: string;
  dispensaryId: string;
};

export function setConciergeReferrer(path: string | null | undefined, dispensaryId: string | null | undefined): void {
  if (!path || !dispensaryId) return;
  try {
    const stored: StoredReferrer = { path, dispensaryId };
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    // best-effort
  }
}

// Single-use *and* dispensary-scoped: single-use alone doesn't stop a
// bookmarked/deep-linked concierge entry (bypassing useConciergeNavigate) from
// inheriting a referrer left over from a different dispensary's session.
export function consumeConciergeReferrer(currentDispensaryId: string | null | undefined): string | undefined {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    window.sessionStorage.removeItem(STORAGE_KEY);

    const stored = JSON.parse(raw) as Partial<StoredReferrer>;
    if (!stored.path || !stored.dispensaryId || !currentDispensaryId || stored.dispensaryId !== currentDispensaryId) {
      return undefined;
    }
    return stored.path;
  } catch {
    return undefined;
  }
}
